import { PAIRED_SALES_API } from '@aloft/toolkit-shared';

import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { StudiesModule } from '../../modules/studies/StudiesModule.tsx';
import { useNewStudiesState } from '../hooks/useNewStudiesState.ts';

export const StudiesRouteElement = () => {
  const studiesContext = useNewStudiesState();

  const { data } = studiesContext.studies;

  const studies =
    data === undefined
      ? undefined
      : PAIRED_SALES_API.GET.RESPONSE.parse(data).results?.sort((a, b) =>
          b.createdAt.compare(a.createdAt),
        );

  return (
    <ModuleContainer compact overflow="hidden" moduleID="studies" title="My Library">
      <StudiesModule studies={studies ?? []} />
    </ModuleContainer>
  );
};
